import { Typography } from "@mui/material";

export type IntroStageProps = {
    localisations: {
        heading: string;
        paragraphs: string[]
    }
}

function IntroStage({localisations} : IntroStageProps) {
    return (
        <>
            <Typography variant="h5" gutterBottom>
                {localisations.heading}
            </Typography>

            {localisations.paragraphs.map((x, index) =>                 
                <Typography key={index.toString()} variant="body1" gutterBottom>
                    {x}
                </Typography>                
            )}
        </>
    );
}

export default IntroStage;
